export default __webpack_public_path__ + "static/3-493fc088eef12818eadf033d13bacc6e.png";